import { render, staticRenderFns } from "./MSidebar.vue?vue&type=template&id=1bd7eb35&"
import script from "./MSidebar.vue?vue&type=script&lang=js&"
export * from "./MSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports